"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../fields/index");

var _Condition = _interopRequireDefault(require("./Condition/Condition"));

var _RefusedBloodDonor = _interopRequireDefault(require("./RefusedBloodDonor/RefusedBloodDonor"));

var _ReceivedBloodTransfusion = _interopRequireDefault(require("./ReceivedBloodTransfusion/ReceivedBloodTransfusion"));

var _medicalHistoryConfig = require("./medicalHistoryConfig");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("componentKey", _flowRuntime["default"].string())));

var MedicalHistoryFields = function MedicalHistoryFields(_arg) {
  var componentKey = _arg.componentKey;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, "Please answer the following questions to the best of your ability."), /*#__PURE__*/_react["default"].createElement("p", null, "Answers to these questions will not necessarily exclude you from the register. We will contact you in the future if we need more information."), /*#__PURE__*/_react["default"].createElement(_RefusedBloodDonor["default"], {
    parentKey: componentKey
  }), /*#__PURE__*/_react["default"].createElement(_ReceivedBloodTransfusion["default"], {
    parentKey: componentKey
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "medical_conditions_wrapper"
  }, /*#__PURE__*/_react["default"].createElement("h3", null, "Please select which, if any, of the following conditions you have ever had"), /*#__PURE__*/_react["default"].createElement("p", null, "Having any of these conditions will not necessarily exclude you from the register. However we may contact you in the future if we need more information."), _medicalHistoryConfig.conditionDefinitions.map(function (conditionDefinition) {
    return /*#__PURE__*/_react["default"].createElement(_Condition["default"], {
      key: conditionDefinition.key,
      condition: {
        key: conditionDefinition.key,
        label: conditionDefinition.label || '',
        type: 'condition'
      },
      parentKey: componentKey
    });
  })), /*#__PURE__*/_react["default"].createElement(_index.Textfield, {
    key: _medicalHistoryConfig.otherInformation.key,
    textfield: _medicalHistoryConfig.otherInformation
  }));
};

var _default = MedicalHistoryFields;
exports["default"] = _default;